import React from 'react';
import FileUpload from './FileUpload';

export default function FileUploadAdmin(props) {
  return <FileUpload {...props} />;
}
